import { getRfqDocument } from '@/api/file.api'

export const FETCH_RFQ_DOCUMENT = 'FETCH_RFQ_DOCUMENT'
export const FETCH_RFQ_DOCUMENT_LOADING = 'FETCH_RFQ_DOCUMENT_LOADING'
export const FETCH_RFQ_DOCUMENT_DONE = 'FETCH_RFQ_DOCUMENT_DONE'
export const FETCH_RFQ_DOCUMENT_ERROR = 'FETCH_RFQ_DOCUMENT_ERROR'

export default {
  [FETCH_RFQ_DOCUMENT] (context, {id, rfqNumber}) {
    context.commit(FETCH_RFQ_DOCUMENT_LOADING)
    return getRfqDocument({id, rfqNumber})
      .then((response) => {
        context.commit(FETCH_RFQ_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_RFQ_DOCUMENT_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/file/rfq/actions.js